import { Box, Button, Stack, Typography } from "@mui/material";
import { ApiQueries, DaymapDialog, DaymapIcon, DaymapIconType, Ismg, MarkingInfo, RubricTable, RubricType } from "daymap-react";
import React, { useState } from "react";

type RubricResultsProps = {
  studentId: number;
  taskId: number;
  rubricId: number;
}

export const RubricResults: React.FC<RubricResultsProps> = ({ taskId, studentId, rubricId }) => {
    const { data: rubric, isPending } = new ApiQueries.rubrics.Rubrics({ rubricId }).ToQuery();
    const [fullScreen, setFullScreen] = useState(false);
    const [showMarkingInfo, setShowMarkingInfo] = useState(false);

    if (isPending)
        return null;

    if (rubric?.RubricType === RubricType.Rubric)
        return <Stack gap={.5}>
        {fullScreen && <DaymapDialog fullScreen showFullScreenControls title={rubric.Title} open={fullScreen} onClose={() => setFullScreen(false)} maxWidth={false}>
            <RubricTable rubricId={rubricId} taskId={taskId} studentId={studentId} sx={{ maxHeight: '100%' }} />
        </DaymapDialog>}
        <MarkingInfo open={showMarkingInfo} onClose={() => setShowMarkingInfo(false)} />
        <Box display="flex" justifyContent="space-between" alignItems="end">
            <Typography variant="h3">Rubric</Typography>
            <Box display="flex" gap={1} alignSelf="flex-end">
                <Button startIcon={<DaymapIcon iconType={DaymapIconType.Info} />} onClick={() => setShowMarkingInfo(true)}>Marking</Button>
                <Button startIcon={<DaymapIcon iconType={DaymapIconType.FullScreen} />} onClick={() => setFullScreen(true)}>Full screen</Button>
            </Box>
        </Box>
        <RubricTable rubricId={rubricId} taskId={taskId} studentId={studentId} sx={{ maxHeight: '70vh' }} />
    </Stack>

    if (rubric?.RubricType === RubricType.ISMG)
        return <Ismg rubricId={rubricId} taskId={taskId} studentId={studentId} />
}

